'use client';

import React from "react";
import { IndividualsPage } from "./IndividualsPage";
import { IndividualsContext, defaultCopy } from "./internals";
import { ToastProvider } from "./components/Toaster";

/**
 * @aumonline/individuals — portable Individual Customers module.
 *
 * Phone-keyed roster of people you've won. Host injects everything.
 *
 * Props:
 *  - storage:     INDIVIDUALS_STORAGE_INTERFACE (required)
 *  - currentUser: { role }  — gates delete to owner/admin
 *  - copy:        optional copy overrides
 */
export const IndividualsModule = ({ storage, currentUser, copy }) => {
  if (!storage) throw new Error("<IndividualsModule> requires a `storage` prop.");
  const value = React.useMemo(
    () => ({ storage, currentUser: currentUser || {}, copy: { ...defaultCopy, ...(copy || {}) } }),
    [storage, currentUser, copy]
  );
  return (
    <IndividualsContext.Provider value={value}>
      <ToastProvider>
        <IndividualsPage />
      </ToastProvider>
    </IndividualsContext.Provider>
  );
};

export default IndividualsModule;
